import { Component, inject, OnDestroy } from '@angular/core';
import { AuthService } from './core/services/auth.service';
import { ThemeService } from './core/theme/theme.service';
import { RouterModule } from '@angular/router';
import { ModalHostComponent } from './shared/ui/layout/modal-host/modal-host.component';
import { LoadingService } from './shared/ui/loading/loading.service';
import { LoadingComponent } from './shared/ui/loading/loading.component';
import { EnvironmentRibbonComponent } from './shared/ui/environment-ribbon/environment-ribbon.component';
import { AppUpdateBannerComponent } from './shared/ui/app-update-banner/app-update-banner.component';
import { UserService } from './core/services/user.service';
import { AssetService } from './core/services/asset.service';
import { FleetService } from './core/services/fleet.service';
import { AppVersionService } from './core/services/app-version.service';

@Component({
  selector: 'app-root',
  imports: [
    RouterModule,
    ModalHostComponent,
    LoadingComponent,
    EnvironmentRibbonComponent,
    AppUpdateBannerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnDestroy {
  title = 'haulverse-admin';
  private themeService = inject(ThemeService);
  protected authService = inject(AuthService);
  protected loadingService = inject(LoadingService);
  private readonly userService = inject(UserService);
  private readonly assetService = inject(AssetService);
  private readonly fleetService = inject(FleetService); // This will auto-initialize
  private readonly appVersionService = inject(AppVersionService);

  constructor() {
    this.themeService.loadTheme();
    this.appVersionService.init();
  }


  ngOnDestroy() {
    this.userService.destroy();
    this.assetService.destroy();
  }
}
